import { twMerge } from '@shared/themes';
import type { BundleStatus } from '../Offer/types';
import { StepIndicator } from './components/StepIndicator/StepIndicator';
import type { Step } from './types';

type StepProgressListProps = {
  steps: Step[];
  className?: string;
  isOfferDisabled?: boolean;
  namespace: string;
  bundleStatus?: BundleStatus;
  offerType?: string;
  stepNumberOffset?: number;
};

function StepProgressList({ steps, className, isOfferDisabled = false, namespace, bundleStatus, offerType, stepNumberOffset = 0 }: StepProgressListProps) {
  return steps.map((step, index) => (
    <div
      key={index}
      className={twMerge('py-4', className)}
      data-track-container="Offer"
      data-track-offer-id={step.bonusInfoData?.offerCode}
      data-track-offer-step={step.actionType}
      data-track-offer-step-status={step.status}
    >
      <StepIndicator
        index={index + 1 + stepNumberOffset}
        step={step}
        isLastStep={index === steps.length - 1}
        isOfferDisabled={isOfferDisabled}
        namespace={namespace}
        bundleStatus={bundleStatus}
        offerType={offerType}
      />
    </div>
  ));
}

export { StepProgressList };
